export default {"src":"/_next/static/media/graphic3.c99405f5.svg","height":160,"width":161,"blurWidth":0,"blurHeight":0};